(() => {
  const init = (root) => {
    if (!root || root.dataset.ttgReady === 'true') return;
    root.dataset.ttgReady = 'true';

    const filterButtons = Array.from(root.querySelectorAll('[data-ttg-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-ttg-card]'));
    const result = root.querySelector('[data-ttg-result]');
    const products = root.querySelector('#ttg-products');
    const mobileCta = root.querySelector('.ttg-lp__mobile-cta');

    const pushEvent = (eventName, details = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...details });
    };

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.ttgFilter || 'all';
        let visibleCount = 0;

        filterButtons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        cards.forEach((card) => {
          const filters = (card.dataset.filters || '').split(',').map((item) => item.trim());
          const visible = filter === 'all' || filters.includes(filter);
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        if (result) result.textContent = `${visibleCount}商品を表示しています`;
        pushEvent('ttg_lp_filter', { ttg_filter: filter, visible_products: visibleCount });
      });
    });

    root.querySelectorAll('[data-ttg-product-link]').forEach((link) => {
      link.addEventListener('click', () => {
        pushEvent('ttg_lp_product_click', {
          product_title: link.dataset.productTitle || '',
          product_handle: link.dataset.productHandle || '',
          link_location: link.classList.contains('ttg-lp__product-media') ? 'image' : 'card'
        });
      });
    });

    root.querySelectorAll('[data-ttg-anchor]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    if (mobileCta && products && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => mobileCta.classList.toggle('is-hidden', entry.isIntersecting));
      }, { threshold: 0.08 });
      observer.observe(products);
    }
  };

  const initAll = () => document.querySelectorAll('[data-ttg-lp]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-ttg-lp]') || event.target.closest('[data-ttg-lp]');
    init(root);
  });
})();
